<script>
import axios from 'axios';
import { mapActions } from 'pinia';

import { useUserStore } from '../../../store/useUserStore.js';
import * as API from '../api/followers';

export default {
    name: 'CpFollowersButton',
    components: {
        CpButton: require('../button').default
    },
    props: {
        follower: Boolean,
        route: String,
        userId: Number,
    },
    data() {
        return {
            followerState: this.follower,
            formErrors: {},
            formSuccess: {},
            loading: false,
        };
    },
    methods: {
        follow() {
            this.loading = true;
            API.follow(this.userId)
                .then(async response => {
                    this.loading = false;
                    this.followerState = true;
                    await this.handleChatEnabled(this.userId);
                })
                .catch(error => {
                    this.loading = false;
                    this.formErrors['message'] = error.response;
                    this.$forceUpdate();
                });
        },
        unfollow() {
            this.loading = true;
            API.unfollow(this.userId)
                .then(async response => {
                    this.followerState = false;
                    this.loading = false;
                    await this.handleChatEnabled(this.userId);
                })
                .catch(error => {
                    this.loading = false;
                    this.formErrors['message'] = error.response;
                    this.$forceUpdate();
                });
        },
        ...mapActions(useUserStore, ['handleChatEnabled']),
    }
};
</script>

<template>
    <transition name="fade" mode="out-in">
        <span v-if="!this.followerState" key="follow">
            <cp-button primary @click="follow" :loading="loading" :disabled="loading">
                Follow User
            </cp-button>
        </span>
        <span v-else key="unfollow">
            <cp-button primary @click="unfollow" :loading="loading" :disabled="loading">
                Unfollow User
            </cp-button>
        </span>
    </transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity .2s ease;
}
.fade-enter,
.fade-leave-to {
    opacity: 0.5;
}
</style>